//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

export default angular.module('curalate.promoted-posts-metrics', ['curalate']);
